module.exports = __webpack_public_path__ + "img/大米.75edfbf3.png";